const addCommas = (num: string) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const removeNonNumeric = (num: string) =>
  num.toString().replace(/[^0-9\.]/g, "");

export const thousandSeparator = (inp: string): string => {
  if (!inp && inp.length === 0) return inp;

  if (containsCharachters(inp)) return inp;

  let retVal: string;
  if (inp.indexOf(".") === -1) return addCommas(removeNonNumeric(inp));
  else {
    const tepVar: string[] = inp.split(".");
    retVal = addCommas(removeNonNumeric(tepVar[0])) + "." + tepVar[1];
    return retVal;
  }
};

export const removeCommas = (inp: string): string => {
  return inp.replaceAll(",", "");
};

function containsCharachters(str: string) {
  return /[^0-9\.]/.test(str);
}
